import React from 'react';
import './Spacer.scss';

const Spacer: React.FC = () => <div className="Spacer" />;

export default Spacer;
